import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokens } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me when returning from Google OAuth: AuthCallback establishes the session first
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = useCallback((data) => {
    tokens.save(data);
    const { access_token, refresh_token, ...u } = data;
    setUser(u);
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      tokens.clear();
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, refreshUser: checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
